<br/>
<form *ngIf="!showMessage || edit" [formGroup]="form" style="min-width:500px;">
  <div class="form-group">
    <label for="SystemLockOutMessage">
      Informationstext
    </label>
    <textarea rows="4" class="form-control form-control-sm" id="SystemLockOutMessage" formControlName="SystemLockOutMessage"></textarea>
  </div>
  <div class="form-group">
    <label>Systemet beräknas vara nedstängt från</label>
    <app-calendar-timestamp [form]="form" [showTime]=true formName="LockOutFrom" [required]=true (change)="setDateFormat()"></app-calendar-timestamp>
    <label>Systemet beräknas vara nedstängt till</label>
    <app-calendar-timestamp [form]="form" [showTime]=true formName="LockOutUntil" [required]=true (change)="setDateFormat()"></app-calendar-timestamp>
  </div>
</form>
<br/>
<div *ngIf="ongoinglockout && showMessage" style="width:700px;">
  <p style="color:black;font-weight:bold;background-color:#F0F0F0;opacity:0.5;border:2px solid blue;border-radius:10px;padding:10px;">
    {{ongoinglockout.systemLockOutMessage}} {{ongoinglockout.lockOutUntil | date: 'yyyy-MM-dd HH:mm'}}
    <br />
    <span style="font-size:10pt;"><i>Låst av: {{ongoinglockout.lockedOutByMemberId}}</i> <i *ngIf="ongoinglockout.lastEditedByMemberId!==ongoinglockout.lockedOutByMemberId" class="ms-5">Låsning uppdaterad av: {{ongoinglockout.lastEditedByMemberId}}</i></span>
  </p>
</div>
<span>
  <button *ngIf="!showMessage && !edit" class="btn" [disabled]="!form.valid" (click)="lockSystem()">Lås systemet</button>
  <button *ngIf="showMessage && !edit" class="btn" (click)="editLockedSystem()">Editera låsning</button>
  <button *ngIf="showMessage && !edit" class="btn ms-5" (click)="unlockSystem()">Lås upp systemet</button>
  <button *ngIf="showMessage && edit" class="btn" (click)="updateLockSystem()">Uppdatera</button>
  <button *ngIf="showMessage && edit" class="btn ms-5" (click)="cancelEdit()">Avbryt</button>
</span>
<br><br>
<div *ngIf="!ongoinglockout && form.get('LockOutUntil').value" class="infotext">
  {{form.get('SystemLockOutMessage').value}}
  <br/>
  <b>{{form.get('LockOutUntil').value}}</b>.
</div>
